import { RiderSourceTypeEnum } from 'app/models';

export class RiderSourceType {
    public static RiderSourceTypeList: Array<any> = [
        { id: RiderSourceTypeEnum.None, name: 'All' },
        { id: RiderSourceTypeEnum.ImportFromFile, name: 'Import' },
        { id: RiderSourceTypeEnum.CreateByAdmin, name: 'Admin' },
        { id: RiderSourceTypeEnum.MobileApp, name: 'Rider App' }
    ];
}
